import React, { useState } from "react";
import { Upload, Typography, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import UploadFileImg from "../../../assets/images/uploadFile.png";
import "./fileUpload.scss";
import { toast } from "react-toastify";

const { Dragger } = Upload;

const BulkFileUpload = ({ setUploadedFile }) => {
  const [fileList, setFileList] = useState([]);

  const beforeUpload = (file) => {
    const isExcelOrCsv =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.type === "text/csv";

    if (!isExcelOrCsv) {
      toast.error("Only Excel or CSV files are allowed!");
      return Upload.LIST_IGNORE;
    }

    const isLt10MB = file.size / 1024 / 1024 < 10;
    if (!isLt10MB) {
      toast.error("File must be smaller than 10MB!");
      return Upload.LIST_IGNORE;
    }

    setFileList([file]);
    setUploadedFile?.(file);
    return false;
  };

  const handleRemove = () => {
    setFileList([]);
    setUploadedFile?.(null);
  };

  return (
    <div className="uploadFile">
      <Dragger
        beforeUpload={beforeUpload}
        fileList={fileList}
        showUploadList
        accept=".xls,.xlsx,.csv"
        maxCount={1}
        className="customDragger"
        onRemove={() => {
          setFileList([]);
          setUploadedFile?.(null);
        }}
      >
        <>
          <p className="label2">Upload Bulk Excel/CSV File</p>
          <img src={UploadFileImg} alt="Upload Icon" />
          <p className="dragDrop">
            Drag & drop or <span>Choose file</span>
          </p>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            Only .xls, .xlsx, or .csv files. Max size: 10MB.
          </Typography.Text>
        </>
      </Dragger>

      {/* {fileList.length > 0 && (
        <div className="image-preview">
          <Typography.Text strong>{fileList[0].name}</Typography.Text>
          <Button
            icon={<CloseOutlined />}
            type="text"
            onClick={handleRemove}
            style={{ marginLeft: "10px", color: "red" }}
          >
            Remove
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default BulkFileUpload;
